export class AzureAudioManager {
  private static instance: AzureAudioManager | null = null;
  private activeAudio: HTMLAudioElement | null = null;
  private activeInstanceId: string | null = null;

  private constructor() {}

  static getInstance(): AzureAudioManager {
    if (!AzureAudioManager.instance) {
      AzureAudioManager.instance = new AzureAudioManager();
    }
    return AzureAudioManager.instance;
  }

  setActiveAudio(audio: HTMLAudioElement | null, instanceId: string | null) {
    console.log('AzureAudioManager: Setting active audio', { instanceId, hasAudio: !!audio });
    
    // Stop previous audio if different instance
    if (this.activeAudio && this.activeInstanceId !== instanceId) {
      console.log('AzureAudioManager: Stopping previous audio', this.activeInstanceId);
      this.stopActiveAudio();
    }
    
    this.activeAudio = audio;
    this.activeInstanceId = instanceId;
  }

  stopActiveAudio() {
    if (this.activeAudio) {
      console.log('AzureAudioManager: Stopping active audio', this.activeInstanceId);
      try {
        const audio = this.activeAudio;
        
        // Remove event listeners before cleanup to prevent error events
        audio.onerror = null;
        audio.onended = null;
        audio.onplay = null;
        audio.oncanplay = null;
        
        audio.pause();
        audio.currentTime = 0;
        
        // Revoke blob URL if it exists
        if (audio.src && audio.src.startsWith('blob:')) {
          URL.revokeObjectURL(audio.src);
        }
        
        // Use removeAttribute instead of setting src = '' to avoid triggering error events
        audio.removeAttribute('src');
        audio.load(); // Force reload to clear any pending audio
      } catch (error) {
        console.warn('AzureAudioManager: Error stopping audio:', error);
      }
    }
    this.activeAudio = null;
    this.activeInstanceId = null;
  }

  stopAll() {
    console.log('AzureAudioManager: Stopping all Azure audio');
    this.stopActiveAudio();
  }

  getActiveInstanceId(): string | null {
    return this.activeInstanceId;
  }
}